import BaseUseCase from "../../base_use_case.js";

class ShowInvestmentUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/projects/investments/${identifier}`,
      params: {
        findByCode: true
      }
    });
  }
}

const instance = new ShowInvestmentUseCase();
export default instance;